export enum ApiResponseCodeEnum {
  PWDRESET = "PWDRESET",
  FLLOGOUT = "FLLOGOUT"
}
